/**
 * Referral link helpers — capture, persist, expose.
 * Mirrors promoLink.js — sister system for "give 30, get 30" sharing.
 */
const KEY = 'ds_ref_code_v1';
const TTL_DAYS = 60;

export function captureRefFromUrl() {
  if (typeof window === 'undefined') return null;
  try {
    const params = new URLSearchParams(window.location.search);
    const raw = (params.get('ref') || '').trim().toUpperCase();
    if (!raw) return null;
    const safe = raw.replace(/[^A-Z0-9-]/g, '').slice(0, 32);
    if (!safe) return null;
    const payload = { code: safe, captured_at: Date.now() };
    window.localStorage.setItem(KEY, JSON.stringify(payload));
    return safe;
  } catch {
    return null;
  }
}

export function getStoredRefCode() {
  if (typeof window === 'undefined') return null;
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return null;
    const { code, captured_at } = JSON.parse(raw);
    if (!code || !captured_at) return null;
    const ageDays = (Date.now() - captured_at) / (1000 * 60 * 60 * 24);
    if (ageDays > TTL_DAYS) {
      window.localStorage.removeItem(KEY);
      return null;
    }
    return code;
  } catch {
    return null;
  }
}

export function clearStoredRefCode() {
  if (typeof window === 'undefined') return;
  try { window.localStorage.removeItem(KEY); } catch {}
}
